/* sts-ms-box.js — paints the Routine milestones box (v7 handoff 2, 3.3):
 * snippets/sts-milestones-box.liquid, on the homepage hero and the rewards
 * page. The arithmetic is assets/sts-milestones.js; the copy is the Skin
 * Profile block's (assets/sts-loyalty.js), word for word.
 *
 * Where the numbers come from, per box (its JSON island):
 *   doc    the backend's v2 doc (customer metafield sts.loyalty), signed in
 *   list   the shopper's list, resolved by the server, signed in
 *   table  the built-in copy of the lists, for a typed guest or the staff
 *          simulator: the list is resolved here for html[data-sts-type] and
 *          this device's sensitivity level
 * A typed guest has no account and so no spend: $0, every tier locked. The
 * simulator (on: 'demo') shows the preview doc, the same sample as the Skin
 * Profile's (STS.milestones.demoDoc, assets/sts-ms-demo.js, preview themes
 * only): the prototype's spend for the simulated row (Q+ new $0, Q+ customer
 * $400, Q+ stale $750), nothing claimed yet, or the simulator's Routine
 * milestones scenario. Repainted on sts:state, which the
 * simulator fires when it switches row or type.
 */
(function (w, d) {
  'use strict';
  var STS = (w.STS = w.STS || {});

  var WORDS = ['', 'one', 'two', 'three', 'four', 'five', 'six'];

  function money(n) {
    var M = STS.money;
    return M ? M.format(Number(n) || 0) : '$' + (Number(n) || 0).toFixed(2);
  }
  function short(n) {
    var s = money(n);
    return s.replace(/\.00(?=\D*$)/, '');
  }
  function name(g) {
    var P = STS.productName;
    return !g ? '' : P ? P(g.brand, g.title) : ((g.brand ? g.brand + ' ' : '') + (g.title || ''));
  }
  function gateLeft(n) {
    return n === 1 ? 'One more paid order unlocks' : n + ' more paid orders unlock';
  }
  function sens() {
    var pv = STS.preview;
    var lv = pv && pv.active && pv.regimen && (pv.regimen.sensitivityLevel || pv.regimen.sensitivity);
    if (lv) return [lv];
    try { return JSON.parse(w.localStorage.getItem('customerSensitivityList') || '[]'); } catch (e) { return []; }
  }
  /* The simulator's sample: ?sts_demo_rewards=N (staff override, the Skin
     Profile's), else the prototype's spend for the simulated row. */
  function demoOpt() {
    var m = /[?&]sts_demo_rewards=(\d{1,2})(?:&|$)/.exec((w.location && w.location.search) || '');
    if (m) return Math.min(4, Number(m[1]));
    return { spend: STS.milestones.demoSpend(d.documentElement.getAttribute('data-sts-state') || '') };
  }
  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; });
  }

  function paint(host) {
    var M = STS.milestones;
    var node = host.querySelector('[data-sts-msbox-data]');
    if (!M || !node) return;
    var data = host.__msData;
    if (!data) {
      try { data = JSON.parse(node.textContent) || {}; } catch (e) { data = {}; }
      host.__msData = data;
    }
    var type = d.documentElement.getAttribute('data-sts-type') || '';
    var list = data.list && data.list.type === type ? data.list : data.table && type ? M.fromTable(data.table, type, sens()) : data.list;
    var gifts = (list && list.gifts) || [];
    /* The simulator's milestone scenario (its Milestones control), else the
       prototype's sample for the simulated row. */
    var pv = STS.preview;
    var doc = data.on === 'demo' && M.demoDoc ? M.demoDoc(list, demoOpt(), pv && pv.active && pv.selection && pv.selection.ms)
      : data.doc && Number(data.doc.v) === 2 ? data.doc : null;
    if (doc && doc._list) { list = doc._list; gifts = list.gifts || []; }
    var cyc = (doc && doc.cycle) || {};
    var cy = M.cycle(doc);
    var spend = cy.spend;
    var rewards = cyc.rewards || [];
    /* The cycle's frozen amounts from the doc (engine §6.10), else the list's. */
    var amounts = M.amounts(doc, gifts);
    var n = amounts.length;
    var gated = cy.left > 0;
    var states = amounts.map(function (a, i) { return M.tierState(rewards[i], i, a, spend, gated); });
    var nx = M.nextTier(states, amounts, spend, cy.deficit, doc);
    var h = nx.i;
    /* The Skin Profile's count: this cycle's unlocked gifts plus any carried over. */
    var unclaimed = states.filter(function (st, i) { return st === 'unlocked' && (rewards[i] || data.on === 'demo'); }).length
      + ((doc && doc.carryover) || []).filter(function (r) { return r && M.tierState(r, -1, 0, 0) === 'unlocked'; }).length;

    /* §3.3 eligible:false: the explainer, never the ladder (CSS on the
       attribute; the server set it already for a real account). */
    var why = M.reason(doc);
    /* ...and nothing to claim: the rewards tile reads this count. With no
       skin type nothing counts at all (DECISIONS). */
    if (why) unclaimed = 0;
    if (why === 'no_skin_type') spend = 0;
    if (why) host.setAttribute('data-sts-ms-reason', why); else host.removeAttribute('data-sts-ms-reason');
    var outT = host.querySelector('[data-sts-msbox-out-text]');
    if (outT) outT.textContent = why === 'holdout' ? 'Rolling out to accounts over the coming weeks. Purchases right for your skin type already count, so nothing is lost while you wait.'
      : why === 'no_skin_type' ? 'Take the quiz to start earning. Products right for your skin type count toward free full-size gifts.'
        : why === 'blocked' ? 'We\u2019re reviewing your rewards. We\u2019ll email you soon.'
          : 'Routine milestones are not available on this account.';
    var outQ = host.querySelector('[data-sts-msbox-out-quiz]');
    if (outQ) outQ.hidden = why !== 'no_skin_type';

    /* §9.2 typed guest: "Sign in to see your gifts" — the box opens sign-in. */
    var a = host.querySelector('a.sts-msbox');
    var guest = d.documentElement.getAttribute('data-sts-guest') === '1' || (!data.signed && data.on === '1');
    if (a) {
      if (!a.__href) a.__href = a.getAttribute('href');
      a.setAttribute('href', guest && data.login ? data.login + '?return_url=' + encodeURIComponent(a.__href) : a.__href);
      var go = host.querySelector('.sts-msbox__go');
      if (go) go.textContent = guest ? 'Sign in to see your gifts \u2192' : 'View \u2192';
    }

    var badge = host.querySelector('[data-sts-msbox-badge]');
    if (badge) {
      badge.textContent = String(unclaimed);
      badge.hidden = unclaimed === 0;
      badge.setAttribute('aria-label', unclaimed + (unclaimed === 1 ? ' gift' : ' gifts') + ' to claim');
    }
    var sp = host.querySelector('[data-sts-msbox-spend]');
    if (sp) sp.textContent = money(spend) + ' this cycle';

    var line = host.querySelector('[data-sts-msbox-line]');
    if (line) {
      var dots = '';
      amounts.forEach(function (a, i) {
        var st = states[i];
        var done = st === 'claimed' || st === 'reserved';
        var cls = done ? 'claimed' : st === 'unlocked' ? 'unlocked' : st === 'expired' ? 'expired' : i === h ? 'next' : 'locked';
        dots += '<span class="sts-msbox__m is-' + cls + '" style="left:' + M.at(i, n) + '%">'
          + '<span class="sts-msbox__dot" aria-hidden="true">' + (done ? '&#10003;' : st === 'unlocked' ? '&#9733;' : st === 'expired' ? '&times;' : String(i + 1)) + '</span>'
          + '<span class="sts-msbox__amt">' + esc(short(a)) + '</span></span>';
      });
      line.innerHTML = '<span class="sts-msbox__rail"><span class="sts-msbox__fill" style="width:' + M.fill(amounts, spend) + '%"></span>' + dots + '</span>';
    }

    var next = host.querySelector('[data-sts-msbox-next]');
    if (next) {
      var carry = Math.max(0, Number(cyc.carry_next) || 0);
      var toNext = nx.toGo;
      next.textContent = !n ? ''
        : cy.waiting && h > -1 && toNext === 0 ? 'Your next order unlocks your free gift at ' + short(amounts[h]) + ', the ' + name(gifts[h]) + '.'
        : spend === 0 && h === 0 && !cy.deficit ? 'Your first free gift, the ' + name(gifts[0]) + ', unlocks on your first ' + short(amounts[0]) + '.'
          /* Only when the config asks for 2+ paid orders (M.gateLeft). */
          : gated && spend >= amounts[0] && states[0] === 'locked'
            ? 'You have reached ' + short(amounts[0]) + '. ' + gateLeft(cy.left) + ' your first free gift.'
          : h > -1 ? money(toNext) + ' more to unlock your free gift at ' + short(amounts[h]) + ', the ' + name(gifts[h]) + '. Once it unlocks, claim it under \u201cView milestone rewards\u201d and it goes in your cart free.'
            : 'All ' + (WORDS[n] || n) + ' gifts earned. ' + (carry > 0
              ? 'The extra ' + money(carry) + ' you spent already counts toward your next cycle, which starts with your next order.'
              : 'Your next order starts a fresh line.');
    }
    /* The gate, a refund deficit, carry-over, the cycle's last 30 days; on the
       rewards card also the retake nudge (§9.2). */
    var ns = host.querySelector('[data-sts-msbox-notes]');
    if (ns) {
      var L = M.notes(cy, { fmt: money, date: function (iso) { return (STS.fmtDate && STS.fmtDate(iso)) || String(iso); }, toNext: nx.toGo,
        first: states[0] === 'locked' && !(spend >= amounts[0]) });
      var t = L.map(function (x) { return x.text; });
      if (cy.levelDefault && host.getAttribute('data-surface') === 'rewards') t.push('Answer one question to get gifts picked for your sensitivity.');
      ns.textContent = t.join(' ');
      ns.hidden = !t.length;
    }
    host.setAttribute('data-sts-ms-unclaimed', String(unclaimed));
    if (n) host.setAttribute('data-sts-ms-cap', String(amounts[n - 1]));
    host.setAttribute('data-sts-ms-ready', '1');
  }

  function all() {
    Array.prototype.forEach.call(d.querySelectorAll('[data-sts-msbox]'), paint);
  }

  d.addEventListener('sts:state', all);
  d.addEventListener('sts:preview', all);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', all);
  else all();
})(window, document);
